import { getRootStatus } from '../../native/RootDetectionPlugin';

/**
 * Calls native RootDetectionPlugin and returns true if the device
 * is rooted with confidence >= 3 (high risk), false otherwise.
 */
export const checkRootDetectionApi = async (): Promise<boolean> => {
  const status = await getRootStatus();
  return status.rooted && status.confidence >= 3;
};
